import React, { PureComponent } from 'react';
import { ResponsiveContainer, PieChart, Pie, Legend } from 'recharts';
import './PieChart1.css';

function PieChart1() {
  const data = [
    { name: 'Group A', value: 400 },
    { name: 'Group B', value: 300 },
    { name: 'Group C', value: 300 },
    { name: 'Group D', value: 200 },
  ];
     
  return (
    <div style={{ width: '50%', height: 300 }}>
    <ResponsiveContainer>
      <PieChart>
        <Pie dataKey="value" data={data} fill="#8884d8" label />
      </PieChart>
    </ResponsiveContainer>
  </div>
  )
}

export default PieChart1